<template>
  <el-dialog
      v-el-drag-dialog
      class="ImportOrderModal"
      title="导入"
      :visible.sync="visible"
      top="10vh"
      width="600px"
      @close="$reset('form')">
    <el-form ref="form" :model="model" label-width="120px" element-loading-text="努力加载中">
      <el-form-item label="销售订单编号">
        <el-input v-model="model.salesOrderNo" placeholder="请输入销售订单编号"/>
      </el-form-item>
      <el-form-item label="客户合同号">
        <el-input v-model="model.customerPurchaseOrderNo" placeholder="请输入客户合同号"/>
      </el-form-item>
      <el-form-item label="ERP销售订单号">
        <el-input v-model="model.erpSalesOrderNo" placeholder="请输入ERP销售订单号"/>
      </el-form-item>
      <el-form-item label="开始日期">
        <el-date-picker
            v-model="model.beginDate"
            style="width: 100%"
            type="date"
            value-format="yyyy-MM-dd"
            :clearable="false"
            placeholder="请选择开始日期"/>
      </el-form-item>
      <el-form-item label="结束日期">
        <el-date-picker
            v-model="model.endDate"
            style="width: 100%"
            type="date"
            :clearable="false"
            value-format="yyyy-MM-dd"
            placeholder="请选择结束日期"/>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="handleOk">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        visible: false,
        submitLoading: false,
        model: {},
      };
    },

    methods: {
      open() {
        this.visible = true;
      },

      // 提交
      handleOk() {
        if (JSON.stringify(this.model) == "{}") {
          this.$confirm("导入信息不可全部为空", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        if (this.model.beginDate && !this.model.endDate) {
          this.$confirm("请选择结束日期", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        if (this.model.endDate && !this.model.beginDate) {
          this.$confirm("请选择开始日期", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        if (new Date(this.model.endDate).getTime() < new Date(this.model.beginDate).getTime()) {
          this.$confirm("请选择有效的日期范围", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.submitLoading = true;
        this.$http.post("basic", "sd/so/erp/import", this.model).then((res) => {
          if (res.success) {
            this.$emit("import-success");
            this.$message.success("导入成功");
          }
          this.submitLoading = false;
          this.visible = false;
        });
      },
    },
  };
</script>
